import { createSlice } from '@reduxjs/toolkit';

let initialState = {
  selectedPlayers: [],
  teamA: null,
  teamB: null,
  constraintsData: null,
  dailyMixApi: null,
  gamedaysData: null,
  overviewApiData: null,
  gameFixtures: null
};

const createTeamSlice = createSlice({
  name: 'createTeam',
  initialState: initialState,
  reducers: {
    playerSelection: (state, action) => {
      const { ply } = action.payload;

      if (Array.isArray(ply)) {
        state.selectedPlayers = ply;
      } else {
        const playerExists = state.selectedPlayers.find((p) => p.id === ply.id);

        if (playerExists) {
          state.selectedPlayers = state.selectedPlayers.filter((p) => p.id !== ply.id);
        } else {
          state.selectedPlayers = [...state.selectedPlayers, ply];
        }
      }
    },
    setTeamA: (state, action) => {
      state.teamA = action.payload; // Update teamA in the state
    },
    setTeamB: (state, action) => {
      state.teamB = action.payload; // Update teamB in the state
    },
    resetTeams: (state) => {
      state.teamA = null; // Reset teamA
      state.teamB = null; // Reset teamB
    },
    setConstraintsData: (state, action) => {
      return { ...state, constraints: action.payload };
    },
    resetPlayers: (state, action) => {
      return { ...state, selectedPlayers: action.payload };
    },
    setDailyMixApiData: (state, action) => {
      return { ...state, dailyMixApi: action.payload };
    },
    setGamedaysData: (state, action) => {
      return { ...state, gamedaysData: action.payload };
    },
    setOverviewApiData: (state, action) => {
      return { ...state, overviewApiData: action.payload };
    },
    setGameFixtures: (state, action) => {
      return { ...state, gameFixtures: action.payload };
    }
  }
});

export const {
  playerSelection,
  setTeamA,
  setTeamB,
  resetTeams,
  setConstraintsData,
  resetPlayers,
  setDailyMixApiData,
  setGamedaysData,
  setOverviewApiData,
  setGameFixtures
} = createTeamSlice.actions;

export default createTeamSlice.reducer;
